module.exports = __webpack_public_path__ + "img/b.16a3a07e.png";